var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('v-chip',{staticClass:"ma-2",attrs:{"color":"green","outlined":"","label":""}},[_vm._v(" Yes ")]):_c('v-chip',{staticClass:"ma-2",attrs:{"color":"red","outlined":"","label":""}},[_vm._v(" No ")])}
var staticRenderFns = []

export { render, staticRenderFns }